import { gql, useMutation } from '@apollo/client';

import { GET_EMPLOYEE_QUESTIONNAIRES_FOR_TABLE } from './get-employee-questionnaires.hook';

export const DECLINE_QUESTIONNAIRES_DOCUMENT = gql`
  mutation declineEmployeeQuestionnaire($payload: UpdateEmployeeQuestionnaireStatusInput!) {
    updateEmployeeQuestionnaireStatus(payload: $payload) {
      _id
    }
  }
`;

export const useDeclineEmployeeDocumentTemplate = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [declineEmployeeQuestionnaire] = useMutation(DECLINE_QUESTIONNAIRES_DOCUMENT, {
    refetchQueries: [GET_EMPLOYEE_QUESTIONNAIRES_FOR_TABLE],
    onCompleted: onSuccess,
  });

  return declineEmployeeQuestionnaire;
};
